import { render, staticRenderFns } from "./ajsl.vue?vue&type=template&id=cbd8eba8&scoped=true&"
import script from "./ajsl.vue?vue&type=script&lang=js&"
export * from "./ajsl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd8eba8",
  null
  
)

export default component.exports